module.exports = __webpack_public_path__ + "img/icon-warning-generic-yellow.abbe8140.svg";